import { useLocalStorage } from '@vueuse/core'
import { computed } from 'vue'

import { buildDateFormatMap } from 'frontend/common/date-format/build-format-map'
import { DateFormatType } from 'frontend/common/date-format/date-format-key'
import { HumanDateFormatType } from 'frontend/common/date-format/human-date-format-type'
import { LOCAL_STORAGE_KEYS } from 'frontend/common/date-format/local-storage-keys'
import { normalizeDateFormat } from 'frontend/common/date-format/normalize-date-format'
import { normalizeTimeFormat } from 'frontend/common/date-format/normalize-time-format'
import { resolveDateFormat } from 'frontend/common/date-format/resolve-date-format'
import { resolveTimeFormat } from 'frontend/common/date-format/resolve-time-format'
import { TimeFormatType } from 'frontend/common/date-format/time-format-key'

export function useDateFormat() {
  const selectedTimeFormat = useLocalStorage<TimeFormatType | null>(
    LOCAL_STORAGE_KEYS.time,
    null,
  )
  const selectedDateFormat = useLocalStorage<DateFormatType | null>(
    LOCAL_STORAGE_KEYS.date,
    null,
  )

  const resolvedTimeFormat = computed(() =>
    resolveTimeFormat(normalizeTimeFormat(selectedTimeFormat.value)),
  )
  const resolvedDateFormat = computed(() =>
    resolveDateFormat(normalizeDateFormat(selectedDateFormat.value)),
  )
  const formatStrings = computed(() =>
    buildDateFormatMap(
      normalizeTimeFormat(selectedTimeFormat.value),
      normalizeDateFormat(selectedDateFormat.value),
    ),
  )

  function getDateFormatString(key: HumanDateFormatType | string): string {
    return (formatStrings.value as Record<string, string>)[key] ?? key
  }

  return {
    selectedTimeFormat,
    selectedDateFormat,
    resolvedTimeFormat,
    resolvedDateFormat,
    formatStrings,
    getDateFormatString,
  }
}
